import { Children, FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider, Scroll, Typography } from '@robocorp/components';
import { styled } from '@robocorp/theme';
import { FilterContainer } from './Container';

const ScrollContainer = styled(Scroll)`
  height: auto;
  > div {
    display: flex;
  }
`;

const Filter = styled(FilterContainer)`
  flex: 1;
`;

const StyledDivider = styled(Divider)`
  margin: 0 ${({ theme }) => theme.space.$8};
  height: 100%;
`;

type SelectAllProps =
  | { onSelectAll: () => void; total: number }
  | { onSelectAll?: undefined; total?: undefined };

type Props = {
  selected: number;
  onDeselect: () => void;
  children: ReactNode;
} & SelectAllProps;

export const SelectFilter: FC<Props> = ({
  children,
  selected = 0,
  onDeselect,
  total,
  onSelectAll,
}) => {
  const { t } = useTranslation();
  return (
    <ScrollContainer variant="custom" horizontal>
      <Filter>
        <Box display="flex" alignItems="center" gap={4}>
          {children}
        </Box>
        {Children.count(children) > 0 && <StyledDivider orientation="vertical" />}
        <Typography color="content.subtle.light">
          {t('filter.selected', { count: selected })}
        </Typography>
        {total !== undefined && selected !== total && (
          <Button onClick={onSelectAll} variant="link">
            {t('filter.selectAll', { count: total })}
          </Button>
        )}
        <Button onClick={onDeselect} variant="link">
          {t('filter.deselect')}
        </Button>
      </Filter>
    </ScrollContainer>
  );
};
